/**
 * Created by PanJiaChen on 16/11/18.
 */
// 获取富文本回显地址
export function getAfterEndUrl() {
  // https://www.haozhihai.cn
  return "/cell";
}

export function getEnvrioment() {
  const name = window.location.href.split("#")[0];
  if (name.includes("8.140.194.219") || name.includes("kanglinbio")) {
    return "prd";
  }
  return "dev";
}
export function getBaseUrl() {
  const isProduction = getEnvrioment() === "prd";
  if (isProduction) {
    return 'https://kanglinbio.com/cell';
  } else {
    // return 'https://www.haozhihai.cn/cell'
    // return 'http://47.100.7.43/cell'
    return "/cell";
  }
}

export function menuFixed() {
  setTimeout(() => {
    var navH = 650 || 0;
    $(window).scroll(function() {
      var scroH = $(this).scrollTop();
      if (scroH >= navH - 65 ) {
        $(".linkBox").css({ position: "fixed", top: 74 });
      } else {
        $(".linkBox").css({ position: "static" });
      }
    });
    var scroH = $(window).scrollTop();

    if (scroH >= navH - 65) {
      $(".linkBox").css({ position: "fixed", top: 74 });
    } else {
      $(".linkBox").css({ position: "static" });
    }
  }, 1200);
}


export function  getParamsByRegex(url = window.location.href) {
  const params = {};
  const regex = /[?&]([^=#]+)=([^&#]*)/g;
  let match;
  while ((match = regex.exec(url))) {
    params[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
  }
  return params;
}


// WEBPACK FOOTER //
// ./src/utils/index.js